import React from 'react';
import { FDStack } from '@facet-wealth/design';
import PropTypes from 'prop-types';
import { InfoBox } from './InfoBox';

const InfoBoxes = ({ collection }) => {
  return (
    <FDStack spacing={2} direction={'column'}>
      {collection.resources().list().map(resource => (
        <InfoBox
          title={resource.attr('title')}
          description={resource.attr('description')}
          key={resource.id()}
        />
      ))}
    </FDStack>
  );
};

InfoBoxes.propTypes = {
  collection: PropTypes.object,
};

export { InfoBoxes };
